module.exports = __webpack_public_path__ + "img/bg.7a5eb935.webp";